// This file centralizes HTTP requests using fusion-http to keep calls short and consistent.
import api from '@coxautokc/fusion-http';

const config = {
  baseUrls: {
    development: {
      app: 'http://localhost:3000',
      api: 'http://localhost:3002' // the mock API URL
    },
    // When you run the production build locally using `npm run build`, you can then serve
    // the app using `serve -s build`. This runs on port 5000.
    localProductionBuild: {
      app: 'http://localhost:5000',
      api: 'http://localhost:3002' // the mock API URL
    },
    production: {
      app: 'https://fusion-starter.firebaseapp.com',
      api: 'TBD'
    }
  }
};

const { get, put } = api(config);

export function getCustomer() {
  return get('customer');
}

export function putCustomer(customer) {
  return put('customer?id=' + customer.id, customer);
}



// WEBPACK FOOTER //
// ./src/api/customerApi.js